import { DeviceConfig, mainDeviceConfig, TypesString } from "./device-config";

export class ioTEmeter implements DeviceConfig{
	config: mainDeviceConfig = {
		sct_device_type: 102,
		isIotah: false,
		isCharglink: false,
		isBattlink: false,
		isBrm: false,
		is_eMeter: false,
		is_iotemeter: true,
		hasTypes: false,
		couldHaveStudy: false,
		typeString: "",
		translationPath: "imThreePhaseExternal.",
		imageFolder: "/iotemeter/",
		logoStyleClass: "im-device-img",
		mapColor: "",
		setLastMaintenanceDate: false,
		hasMaintenanceSchedule: false,
		hasBatterySettings: false,
		CO2data: false,
		permissionMapperKey: "IoTEmeter SP3",
		mapperOverrideFile: "iotemeterMapper",
		supportIncorrectEvent: false,
		hasLoadScheduling: true,
		hasRequestManageDevice: true,
		hasManageDevice: true,
		deviceSettingTabs: ['info', 'deviceSettings', 'networkingSettings', 'networking', 'official-reporting', 'connectivityFrequency', 'loadScheduling', 'eventTypeSettings', 'cal'],
		hasLoadPowerStatusStop: true,
		hasImCalibration: true,
		fields: {
			kwhr: "",
			hasMaxChargerKw: false,
			hasTemperatureSensor: false,
			hasShiftSchedule: false,
			hasWaterLevel: false,
			hasHallEffect: false,
			trickleVoltage: false,
			cvTargetVoltage: false,
			fiTargetVoltage: false,
			eqVoltage: false,
			trickleCurrentRate: false,
			ccRate: false,
			cvEndCurrentRate: false,
			cvCurrentStep: false,
			fiCurrentRate: false,
			eqCurrentRate: false,
			batteryCapacity: false,
			batteryType: false,
			numberOfCells: false,
			batteryTemperatureCompensationInMv: false,
			fiDt: false,
			fiDv: false,
			liftCurrentThresholdPercentage: false,
			liftCurrentThresholdValue: false,
			liftCurrentThresholdDeltaPercentage: false,
			liftCurrentThresholdDeltaValue: false,
			deadManTime: false,
			returnFactor: false,
			batteryEfficiency: false,
			chargerEfficiency: false,
			deadManCurrentLimit: false,
			chargerType: false,
			chargerVoltage: false,
		},
		requiredFields: {
			truckType: false,
			truckManufacturer: false,
			truckManufacturingYear: false,
			truckManufacturingMonth: false,
			currentLiftLowerThreshold: false,
			currentLiftUpperThreshold: false
		},
		incorrectEvent: {
			type: ""
		},
		quarterlyUsage: {
			hasTypeFilter: false,
			hasYearFilter: false,
			performanceChartType: "",
			hasChartLegend: false,
			chartGridColumns: 0,
			hasTotalTravelTimeChart: false,
			hasTotalLiftTimeChart: false,
			period: "months",
			perfAnalyticsKey: ""
		},
		reporting: {
			device: ""
		},
		dailyDetails: {
			hasField: {
				billed_kwh: false,
				accurate_inuse_seconds: false,
				lift_time: false,
				travel_time: false,
				ah_h: false,
				ebu: false,
				eq: false,
				missed_fi: false
			},
			hasTypes: {
				endVoltage: false,
				chargerEndVoltage: false,
				idleTimes: false
			},
			hasOrPowerStudy: {
				min_soc: false
			},
			useBilledKwh: false
		},
		events: {
			hasFields: {
				billed_kwh: false,
				lift_time: false,
				travel_time: false,
				accurate_inuse_seconds: false,
				flag_finish: false,
				flag_eq: false,
				flag_finish_start: false,
				flag_eq_start: false,
				finish_reason: false,
				eq_reason: false,
				fromNode: false,
				hasEnergyColumns: true,
			},
			hasOrPowerStudy: {
				start_soc: false,
				end_soc: false
			}
		},
		usage: {
			summaryField: "",
			accurateSecondsField: ""
		},
		performance: {
			hasEndVoltageReport: false,
			hasInuseEndVoltageReport: false,
			hasChargeEndVoltageReport: false,
			hasIdleEventsReport: false,
			hasImUsageDataReport: true,
			hasImPowerPeakReport: true,
			hasImTotalEnergyUsageReport: true,
			hasRegenReport: false,
			hasUsageAsReport: false,
			hasUsageTimeWidget: false,
			usageSummaryKey: "",
			kwuUsageSummaryKey: "",
			hasDataWidget: false,
			hasRelativeUsageWidget: false,
			hasBatteriesCustomizedCharts: false,
			chargeOpportunity: false,
			hasBatteryPerformance: false,
			hasPowerUsageCharts: false,
			hasUsageReport: false,
			hasTruckHoursReport: false,
			has_soc: false,
			vpc_charts: false,
			water_level_chart: false,
			hasBatteryLifeMetics: false,
			batteryPerformanceScore: false,
			hasBatteryReport: false,
			hasTruckReport: false,
		},
		customer: {
			mix_quarterly_usage_kwh: false
		},
		quickView: {
			hasInsight: true,
			hasLiveEvent: true,
			hasLiveRT: true,
			hasWarnings: true,
			hasCalc: false,
			hasMeterGauge: true,
			hasLoadControl: true,
		},
		rts: {
			has_soc: false,
		},
	}

	getImagePath(imageType: "not_connected" | "connected" | "inuse" | "idle", options?: { is_study_device: boolean; }): string {
		let imageLink = '/images' + this.config.imageFolder;
		switch (imageType) {
			case 'not_connected':
				imageLink += `disconnected-iotemeter.png`;
				break;
			case 'connected':
				imageLink += `connected-iotemeter.png`;
				break;

			default:
				imageLink += `disconnected-iotemeter.png`;
				break;
		}

		return imageLink;
	
	}

	getEventImage(eventType: string, is_study_device: boolean): string {
		throw new Error("Method not implemented.");
	}

	getTypesString(options: { getPowerStudyDevices: boolean; is_study_device: boolean; }): TypesString {
		throw new Error("Method not implemented.");
	}

}